<template>
    <div class="mainbusinessModuleWarp">
        <div class="moduleTitle">人力资源管理咨询服务</div>
        <div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position='top' :validate-on-rule-change="false">
                <div class="dialogformCenter">
                    <div class="bigTitle">一、从业人员</div>
                    <el-form-item label="  1.从业人员总数：" prop="1">
                        <el-input v-model="ruleForm[1]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="  2.本科及以上学历比例（%）：" prop="2">
                        <el-input v-model="ruleForm[2]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="3.研究生学历或硕士以上学位比例（%）：" prop="3">
                        <el-input v-model="ruleForm[3]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">二、服务内容</div>
                    <el-form-item label=" 4.开展多少类人力资源管理咨询服务：" prop="4">
                        <el-input v-model="ruleForm[4]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">三、服务场所及设备设施</div>
                    <el-form-item label="5.服务场所建筑面积（平米）：" prop="5">
                        <el-input v-model="ruleForm[5]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="6.具有投影仪、录音、照相摄像等设备：" prop="6">
                        <el-radio-group v-model="ruleForm[6]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">四、咨询顾问项目</div>
                    <el-form-item label="7.年完成项目数：" prop="7">
                        <el-input v-model="ruleForm[7]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">五、后续服务</div>
                    <el-form-item label="8.为客户设计项目实施计划，培训相关人员：" prop="8">
                        <el-radio-group v-model="ruleForm[8]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="9.客户回访率（%）：" prop="9">
                        <el-input v-model="ruleForm[9]" placeholder="请输入"></el-input>
                    </el-form-item>

                    <el-form-item label="10.提供跟踪服务：" prop="10">
                        <el-radio-group v-model="ruleForm[10]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="11.根据客户需求及时提供后续服务：" prop="11">
                        <el-radio-group v-model="ruleForm[11]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">六、项目评估</div>
                    <el-form-item label="12.项目评估率（%）：" prop="12">
                        <el-input v-model="ruleForm[12]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="13.客户满意度（%）：" prop="13">
                        <el-input v-model="ruleForm[13]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">七、材料归档</div>

                    <el-form-item label="14.材料归档率达（%）：" prop="14">
                        <el-input v-model="ruleForm[14]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">八、客户投诉记录及处理</div>
                    <el-form-item label="15.是否设有投诉电话：" prop="15">
                        <el-radio-group v-model="ruleForm[15]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="16.接到投诉到介入处理再到反馈当事人处理结果所需时间（天）：" prop="16">
                        <el-input v-model="ruleForm[16]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="  17.是否有投诉及处理情况记录" prop="17">
                        <el-radio-group v-model="ruleForm[17]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="18.投诉及处理情况记录保存年限（年）：" prop="18">
                        <el-input v-model="ruleForm[18]" placeholder="请输入"></el-input>
                    </el-form-item>

                </div>
                <div class="dialogformBottomBtnBox" v-if="!result">
                    <el-button type="primary" @click="saveForm" class="submitBtn">保存</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')" class="submitBtn">提交</el-button>
                    <el-button @click="cancelForm" class="cancelBtn">关闭</el-button>
                </div>
                <div class="dialogformBottomBtnBox" v-else>
                    <el-button @click="cancelForm" class="cancelBtn">关闭</el-button>
                </div>
            </el-form>

        </div>
    </div>
</template>
<script>
import { httpService } from "@/service/httpService";
export default {
    props: ['saveId', 'result'],
    data() {
        return {
            ruleForm: {
                1: '',
                2: '',
                3: '',
                4: '',
                5: '',
                6: '',
                7: '',
                8: '',
                9: '',
                10: '',
                11: '',
                12: '',
                13: '',
                14: '',
                15: '',
                16: '',
                17: '',
                18: '',
            },
            rules: {
                // 正整数
                1: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                2: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],

                3: [
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                4: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                // 小数
                5: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                6: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                7: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                8: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                9: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                10: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                11: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                12: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                13: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                14: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                15: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                16: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                17: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                18: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
            },
        }
    },
    created() {
        this.yetData()
    },
    methods: {
        saveForm() {
            let NewDataList = []
            for (const key in this.ruleForm) {
                let obj = {}
                obj.serialNumber = key;
                obj.evaluateValue = this.ruleForm[key]
                NewDataList.push(obj)
            }
            httpService.saveB(this.saveId, NewDataList).then(res => {
                if (res.code == 200) {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    this.$emit('getyetServiceFn')
                }
            })
        },
        // 提交
        submitForm(formName) {
            // 保存不通过validate检验
            this.$refs[formName].validate((valid, obj) => {
                if (valid) {

                    let NewDataList = []
                    for (const key in this.ruleForm) {
                        let obj = {}
                        obj.serialNumber = key;
                        obj.evaluateValue = this.ruleForm[key]
                        NewDataList.push(obj)
                    }
                    httpService.addScore(this.saveId,NewDataList).then(res => {
                        if (res.code == 200) {
                            this.$message({
                                message: '提交成功',
                                type: 'success'
                            });
                            this.$emit('getyetServiceFn')
                            // this.$emit('update:isShow', false)
                            if (!this.isCustom) this.$destroy() // 销毁当前组件
                        }
                    })
                } else {
                    let arr = []
                    for (const key in obj) {
                        if (Object.hasOwnProperty.call(obj, key)) {
                            let ele = key + '题、'
                            arr.push(ele)
                        }
                    }
                    let str = arr.join('')
                    this.$message.error(`${str}未填写，请检查！`);
                    return false;
                }
            });
        },

        cancelForm() {
            this.$emit('getyetServiceFn')
            this.$emit('update:isShow', false)
            if (!this.isCustom) this.$destroy() // 销毁当前组件
            this.$router.push('/evaluate-home')
        },
        // 回填表单数据
        yetData() {
              httpService.getCorpIndicatorOption(this.saveId).then(res => {
                if (res.code == 200) {
                    if (res.result.length != 0) {
                        let obj = {}
                        for (const key in res.result) {
                            obj[res.result[key].serialNumber] = res.result[key].evaluateValue
                        }
                        this.ruleForm = obj
                    }
                }
            })
        },
    }


}
</script>
<style lang="less" scoped>
.mainbusinessModal7Warp {
}
</style>


